import type { WeatherActualKoma } from '~/models/weather/actualKoma'

/** 日内の最高/最低気温とその発生時刻 (サマリーバーのヘッダー)。 */
export type DailyTempRange = {
  maxTemp: number | null
  /** 最高気温コマの開始時刻 "HH:MM"。実測が 1 つも無ければ null。 */
  maxTime: string | null
  minTemp: number | null
  minTime: string | null
}

/**
 * 実績気象系列から日内の最高/最低気温とその時刻を求める。
 *
 * 実測気温を持つコマだけを候補にする (欠測コマを 0℃ として拾わない)。実測が
 * 1 つも無い日 (未来日・取得失敗) は全項目 null で返し、呼び出し側が「—」を
 * 出せるようにする。同値タイは先頭 (早いコマ) を採る — backend の
 * ComputeSlotPeaks と同じ規則に揃えてある。
 *
 * 予想気温 (temperatureForecast) は候補に入れない。サマリーバーが示すのは
 * 「実際にどうだったか」であり、予報値を混ぜると実績とヘッダーの気温がズレる。
 */
export function dailyTempRange(
  series: readonly WeatherActualKoma[],
): DailyTempRange {
  const range: DailyTempRange = {
    maxTemp: null,
    maxTime: null,
    minTemp: null,
    minTime: null,
  }

  for (const koma of series) {
    const temp = koma.temperature
    if (temp === null) {
      continue
    }
    if (range.maxTemp === null || temp > range.maxTemp) {
      range.maxTemp = temp
      range.maxTime = koma.time
    }
    if (range.minTemp === null || temp < range.minTemp) {
      range.minTemp = temp
      range.minTime = koma.time
    }
  }

  return range
}
